// @ts-nocheck
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { ReactNode } from "react";
import siteMessage from "@insite/client-framework/SiteMessage";

interface OrderChangeRequestAvailability {
    canRequestOrderChange: boolean;
    disabledMessage?: ReactNode;
}

const orderChangeDisabledMessages: Record<string, () => ReactNode> = {
    ShipToMismatch: () => siteMessage("OrderDetails.OrderChangeDisabled.ShipToMismatch"),
    Unavailable: () => siteMessage("OrderDetails.OrderChangeDisabled.Unavailable"),
};

const getOrderChangeRequestAvailability = (order?: OrderModel): OrderChangeRequestAvailability => {
    const orderChangeDisabledReason = order?.properties?.orderChangeDisabledReason ?? "";

    return {
        canRequestOrderChange: !orderChangeDisabledReason,
        disabledMessage: orderChangeDisabledReason
            ? (orderChangeDisabledMessages[orderChangeDisabledReason] ?? orderChangeDisabledMessages.Unavailable)()
            : undefined,
    };
};

export default getOrderChangeRequestAvailability;
